module.exports = "<footer class=\"main-footer\">\r\n  <strong>&copy; Big City Promotions</strong> - All Rights Reserved.\r\n  reserved.\r\n</footer>\r\n"